import { asPage } from 'src/components/hoc/asPage'
import { ResponsibilitiesEditor } from 'src/compositions/Profile/Responsibilties'

export default asPage(ResponsibilitiesEditor, { pageTitle: '企業情報編集' })
